
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';

import { SharedModule } from '../shared/shared.module'
import { LandingComponent } from './components/landing.component';
import { InavlidLinkComponent } from './components/invalidlink.component';
import { Welcomeomponent } from './components/welcome.component';
import { CertificationComponent } from './components/certificationcreate.component';
import { DisclaimerComponent } from './components/disclaimer.component';
import { CertificationService } from './services/certification.service';
import { ReviewCertificationComponent } from './components/review-certification.component';
import { ConfirmationComponent } from './components/confirmation.component';
import { RouteResolver } from './services/routeresolver.resolver';

@NgModule({
    declarations: [

        LandingComponent,
        DisclaimerComponent,
        InavlidLinkComponent,
        Welcomeomponent,
        CertificationComponent,
        ReviewCertificationComponent,
        ConfirmationComponent
    ],
    imports: [RouterModule, RecaptchaModule, RecaptchaFormsModule, SharedModule],
    providers: [CertificationService, RouteResolver]
})

export class CertificationModule { }
